// extracted by mini-css-extract-plugin
export default {"container":"Logout_container__hX5ty","message":"Logout_message__NpJWW","bottom":"Logout_bottom__yZ+xF"};